import { createRouter, createWebHistory } from 'vue-router';

import { useSnackbar } from '@/composable/useSnackbar';
import { registerAuthGuard } from '@/router/guards/authGuard';
import routes from '@/router/modules';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

registerAuthGuard(router);

router.afterEach((to, from) => {
  if (to.path !== from.path) {
    useSnackbar().close();
  }
});

export default router;
